export default class LanguageListService {
    constructor(apiService) {
        this.apiService = apiService;
    }

    getEntities(params) {
        return this.apiService.callGet('languageList', params);
    }
}



// WEBPACK FOOTER //
// ./src/service/LanguageListService.js